module.exports = __webpack_public_path__ + "img/header-11.c53766f.jpeg";